import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';
import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class ExpertizeResource {
  private baseUri = '/prl/expertizes';

  constructor(private ApiService: ApiService) {}

  // GET
  findExpertizes(): Observable<Array<Docorga.interfaces.expertize.IExpertizeJson>> {
    return this.ApiService.get(`${this.baseUri}/favorites`);
  }
}
